export default "__VITE_ASSET__8dc24eac__"